import React, { Component } from "react";
import "./Modals.scss";
import {
  modalService,
  modalPopup,
  logOutService,
  logOut,
} from "../../../services/subscriberService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { RowColoumn } from "../Row/Row";
import { Button } from "../Button/button";
import StreamingVideo from "../StreamingVideo/StreamingVideo";
import { UniqueID, CheckValue } from "../../../services/CommonFunction";
import { staticVar } from "../../../services/Constants";
import { Dropdown } from "../Dropdown/Dropdown";
import {
  FieldGroup,
  FieldControl,
  Validators,
  FormBuilder,
} from "react-reactive-form";
import {
  FormGroupRow,
  FormGroups,
} from "../../ReusableComponents/FormGroups/FormGroups";
import { NumberTime, TextArea, RadioInput } from "../FormInput/FormInput";
import { SVG, selectIcon } from "../selector";
import OutsideAlerter from "../../ReusableComponents/OutsideAlerter/OutsideAlerter";

class Modals extends Component {
  state = {
    status: false,
    data: null,
  };

  componentDidMount() {
    this.modalSubscriber = modalService.getModalMessage().subscribe((res) => {
      this.setState({
        data: res.data,
        status: res.status,
      });
      if (!res.status && modalPopup.outside) {
        modalPopup.outside = false;
      }
    });
  }

  componentWillUnmount() {
    this.modalSubscriber.unsubscribe();
  }

  render() {
    const status = this.state.status ? (
      <div className="Backdrop zIndex">
        <div className="historyModals">
          <OutsideAlerter className="modal_div"
            clickOutSide={() => {
              if (modalPopup.outside) {
                ClosePopup();
              }
            }}
          >
              {modalPopup.cross && (
                <div
                  className="oval"
                  onClick={() => {
                    logOut.setLogOut(false);
                    ClosePopup();
                  }}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </div>
              )}
              {this.state.data}
            {/* <div className="modal_div">
            </div> */}
          </OutsideAlerter>
        </div>
      </div>
    ) : null;

    return <React.Fragment>{status}</React.Fragment>;
  }
}

export const ModalB = (props) => (
  <div
    className={`modal-popUp blackB  ${props.class || ""}`}
    style={props.style}
  >
    {props.children}
  </div>
);

export const ModalBlack = (props) => (
  <div
    className={`modal-popUp blackBack  ${props.class || ""}`}
    style={props.style}
  >
    {props.children}
  </div>
);

export const ModalC = (props) => (
  <div className="modal-popUp blackC" style={props.style}>
    {props.children}
  </div>
);

export const ModalW = (props) => (
  <div className={`modal-popUp whiteB ${props.class}`}>{props.children}</div>
);

export const ModalReason = (props) => (
  <div className={`modal-popUp reason ${props.class}`}>{props.children}</div>
);

export const ModalHeader = ({ crossClick, ...props }) => (
  <div className="modal-header" style={props.style}>
    <span className="modal-header-title">{props.title}</span>
    {props.cross && (
      <div className="modal-header-cross" onClick={ClosePopup}>
        <FontAwesomeIcon icon={faTimes} />
      </div>
    )}
    {props.crossNew && (
      <div
        className="modal-header-cross"
        onClick={crossClick ? crossClick : ClosePopup}
      >
        <SVG src={selectIcon("crossIcon")} />
      </div>
    )}
  </div>
);

export const ModalBody = (props) => (
  <div className="modal-body" style={props.style}>
    {props.children}
  </div>
);

export const ModalFooter = (props) => (
  <div className="modal-footer" style={props.style}>
    {props.children}
  </div>
);

export const PopUpModal = (props) => {
  return (
    <ModalB>
      {/* <ModalHeader title="Link Video" /> */}
      <ModalBody>
        <p className="popup_text">
          {props.text || "Are you sure want to do this?"}
        </p>
        {props.note ? (
          <p className="popup_text_note">Note - {props.note}</p>
        ) : null}
        <RowColoumn style={{ justifyContent: "center" }}>
          <Button
            style={{ marginRight: "10px", minWidth: "150px" }}
            className="btns-default"
            label={props.cancelText || "cancel"}
            handleClick={props.close || ClosePopup}
          />
          <Button
            style={{ minWidth: "150px" }}
            handleClick={props.handleClick}
            className="btns-primary"
            label={props.submitText || "submit"}
          />
        </RowColoumn>
      </ModalBody>
    </ModalB>
  );
};

// export const PopUpModalWithNotes = (props) => {
//     return(
//         <ModalB>
//             {/* <ModalHeader title="Link Video" /> */}
//             <ModalBody>
//                 <p className="popup_text">{props.text || 'Are you sure want to do this?'}</p>
//                 {props.note?<p className="popup_text">{props.note}</p>:null}
//                 <RowColoumn style={{ justifyContent: 'center' }}>
//                     <Button style={{ marginRight: '10px', minWidth:'150px' }} className="btns-default" label={props.cancelText || "cancel"} handleClick={props.close || ClosePopup}/>
//                     <Button style={{ minWidth:'150px' }} handleClick={props.handleClick} className="btns-primary" label={props.submitText || "submit"} />
//                 </RowColoumn>
//             </ModalBody>
//         </ModalB>
//     )
// }

export const ClosePopup = () => {
  modalService.sendModalMessage({ status: false, data: null });
  modalPopup.cross = true;
};

export const OpenPopup = (data, showCross = modalPopup.cross) => {
  if (CheckValue(data.props.videoSrc)) {
    modalPopup.cross = true;
  } else {
    modalPopup.cross = showCross;
  }
  modalService.sendModalMessage({ status: true, data: data });
};

export const VideoPopup = (props) => {
  return (
    <div className="video_modal">
      {/* {props.download?<a className="download" download={props.download} ><FontAwesomeIcon icon={faDownload} /></a>:null} */}

      <StreamingVideo
        {...props}
        videoSrc={props.download ? props.download : props.videoSrc}
        customPlayer={false}
      />
    </div>
  );
};

export const ErrorModals = (props) => {
  let close = () => (props.close ? props.close() : null);
  let closePopup = !CheckValue(props.closePopup) || props.closePopup;
  let cancel = true;
  let cancelText = props.cancelText || "Ok";
  let cancelClass = props.cancelClass || "btns-defaults";
  let retry = props.retry;
  let msgs = props.text;
  let statusCode = 0;
  if (typeof props.text === "string") {
    if (
      props.text === staticVar.defaultErrorMsg ||
      props.text === "Connection terminated due to connection timeout"
    ) {
      cancel = false;
    }
  } else if (typeof props.text === "object") {
    if (props.text.data === undefined && props.text.message === undefined) {
      cancel = false;
      msgs = staticVar.defaultErrorMsg;
    } else {
      msgs =
        props.text.message ||
        props.text.data.message ||
        staticVar.defaultErrorMsg;
    }
    statusCode = props.text.statusCode || props.text.data.statusCode || 0;
  } else if (!CheckValue(props.text)) {
    cancel = false;
    msgs = staticVar.defaultErrorMsg;
  }

  if (!retry) {
    cancelClass = props.cancelClass || "btns-primary";
    cancel = true;
    cancelText = props.cancelText || "Ok";
  }
  if (statusCode === 401) {
    retry = false;
    cancelText = "Ok";
    if (!CheckValue(props.whiteLabel)) {
      cancelClass = "btns-primary";
      close = () => {
        logOutService.sendMessage("logout");
        logOutService.sendStopMessage("logout");
      };
    }
  }

  return (
    <MainDivModal clas="errorModalUI">
      <div className="body">
        <span className="text">{msgs}</span>
        {props.note ? <span className="note">{props.note}</span> : null}
      </div>
      {/* <span className="text">Please enter the class duration to schedule without segments.</span> */}
      <div className="footer">
        {retry ? (
          <Button
            label={props.submitText || "Retry"}
            className={props.submitClass || "btns-primary"}
            handleClick={() => {
              modalPopup.cross = true;
              if (closePopup) {
                ClosePopup(true);
              }
              props.retryData();
            }}
          />
        ) : null}
        {cancel ? (
          <Button
            label={cancelText}
            className={cancelClass}
            handleClick={() => {
              modalPopup.cross = true;
              if (closePopup) {
                ClosePopup(true);
              }
              close();
            }}
          />
        ) : null}

        {props.anotherButton ? (
          <Button
            label={props.anotherButtonText}
            className={props.anotherButtonClass}
            handleClick={() => {
              modalPopup.cross = true;
              if (closePopup) {
                ClosePopup(true);
              }
              props.anotherButtonClick();
            }}
          />
        ) : null}
      </div>
    </MainDivModal>
  );
};
export const ConfirmModals = (props) => {
  return (
    <MainDivModal clas="confirmModalUI">
      <div className="body">
        <span className="text">{props.text}</span>
      </div>
      <div className="footer">
        <Button
          label={"Cancel"}
          className={"btns-defaults"}
          handleClick={() => {
            modalPopup.cross = true;
            ClosePopup(true);
          }}
        />
        <Button
          label={"Proceed"}
          className="btns-primary"
          handleClick={() => {
            modalPopup.cross = true;
            ClosePopup(true);
            props.func();
          }}
        />
      </div>
    </MainDivModal>
  );
};

export const ErrorModal = (props) => {
  return (
    <ModalW class="displayF">
      <ModalHeader title={props.title || "Error"} />
      <ModalBody>
        <p className="popup_text error">{props.text || "Error"}</p>
      </ModalBody>
      <ModalFooter>
        <div className="footer">
          {props.retry && (
            <div className="col text-right">
              <Button
                label={props.submitText || "Retry"}
                className="btns-primary"
                handleClick={props.retryData}
              />
              {/* <button className="btn btn-primary" onClick={props.retryData}>{props.submitText || "Retry"}</button> */}
            </div>
          )}
          <div className={props.retry ? "col text-left" : "col text-center"}>
            <Button
              label={props.cancelText || "Close"}
              className={props.cancelClass || "btns-default"}
              handleClick={props.close ? props.close : ClosePopup}
            />
            {/* <button className="btn btn-default" onClick={() => ClosePopup(true)}>{props.cancelText || "Close"}</button> */}
          </div>
        </div>
      </ModalFooter>
    </ModalW>
  );
};

export const OfflineModal = () => {
  return (
    <div className="Backdrop zIndex">
      <div className="historyModals">
        <div className="modal_div">
          <ModalW class="displayF">
            <ModalHeader title={"Error"} />
            <ModalBody>
              <p className="popup_text error">{"Internet not connected"}</p>
            </ModalBody>
            <ModalFooter>
              <div className="footer">
                <div className="col text-right">
                  <Button
                    label={"Retry"}
                    className="btns-primary"
                    handleClick={() => {
                      ClosePopup();
                      window.location.reload();
                    }}
                  />
                </div>
              </div>
            </ModalFooter>
          </ModalW>
        </div>
      </div>
    </div>
  );
};

export const SelectModal = (props) => {
  return (
    <ModalB class="selectModal">
      <ModalHeader
        title={`${props.value.length ? "Re-" : ""}${props.title || "Assign"}`}
      />
      <ModalBody>
        <Dropdown
          depend={false}
          showImage={props.showImage || true}
          id={UniqueID()}
          showOptionList={true}
          optionsList={props.list}
          handleOptionClick={props.click}
          selectedText={props.value}
        />
      </ModalBody>
    </ModalB>
  );
};

export const Errors = (msg, fun = null) => {
  OpenPopup(
    <ErrorModal
      text={msg || "Error"}
      retry={fun !== null}
      retryData={() => {
        ClosePopup();
        fun();
      }}
    />
  );
};
export const ErrorUI = (msg, fun = null, data = {}) => {
  if (data.cross) {
    modalPopup.cross = data.cross;
  } else {
    modalPopup.cross = false;
  }
  OpenPopup(
    <ErrorModals
      text={msg}
      {...data}
      retry={fun !== null}
      retryData={() => {
        fun();
      }}
    />
  );
};
export const ConfirmUI = (msg, func = null) => {
  modalPopup.cross = false;
  OpenPopup(<ConfirmModals text={msg} func={func} />);
};

export const CreateTemplatePopup = (props) => {
  return (
    <ModalB class="templateModal">
      {/* <ModalHeader title="Link Video" /> */}
      <ModalBody>
        <p className="popup_text1">
          {props.text} {props.description || ""}
        </p>
        <RowColoumn style={{ justifyContent: "center" }}>
          <Button
            style={{ marginRight: "10px", minWidth: "150px" }}
            handleClick={() => props.handleClick(true)}
            className="btns-primary"
            label="OK"
          />
          <Button
            style={{ minWidth: "150px" }}
            handleClick={() => props.handleClick(false)}
            className="btns-default"
            label="Cancel"
          />
        </RowColoumn>
      </ModalBody>
    </ModalB>
  );
};

export const DurationModal = ({ form, duration, ...props }) => {
  return (
    <MainDivModal>
      <FieldGroup
        control={form.get("time")}
        render={({ get, invalid, touched }) => (
          <React.Fragment>
            <span className="text">
              Please enter the class duration to schedule without segments.
            </span>
            <FormGroupRow>
              <FormGroups>
                <FieldControl
                  name="hour"
                  render={NumberTime}
                  meta={{
                    label: `Hours`,
                    type: "NumberTime",
                    placeholder: "",
                    valid: false,
                  }}
                />
              </FormGroups>
              <FormGroups>
                <FieldControl
                  name="minute"
                  render={NumberTime}
                  meta={{
                    label: `Minutes`,
                    type: "NumberTime",
                    placeholder: "",
                    valid: false,
                  }}
                />
              </FormGroups>
              <FormGroups>
                <FieldControl
                  name="second"
                  render={NumberTime}
                  meta={{
                    label: `Seconds`,
                    type: "NumberTime",
                    placeholder: "",
                    valid: true,
                  }}
                />
              </FormGroups>
            </FormGroupRow>
            <span className="error">
              {touched &&
                get("total").hasError("min") &&
                `Minimum duration of the class should be at least 1 minute.`}
            </span>
            <FormFooterModal {...props} invalid={invalid} />
          </React.Fragment>
        )}
      />
    </MainDivModal>
  );
};

export const MainDivModal = (props) => (
  <div className={props.clas || "durationModal"}>{props.children}</div>
);
export const TextMotdal = (props) => <span className="text">{props.text}</span>;

export const FormFooterModal = ({ invalid, ...props }) => (
  <div className="footer">
    <Button
      label={props.cancelText || "Cancel"}
      className="btns-defaults"
      handleClick={() => (props.cancel ? props.cancel() : ClosePopup())}
    />
    <Button
      disabled={invalid}
      label={props.submitText || "Publish"}
      className="btns-primary"
      handleClick={props.submit}
    />
  </div>
);

export const FooterModal = ({ submit, cancel }) => (
  <div className="footer">
    {submit ? (
      <Button label={"Yes"} className="btns-secondarys" handleClick={submit} />
    ) : null}
    <Button
      label={submit ? "No" : "Ok"}
      className="btns-primary"
      handleClick={() => (cancel ? cancel() : ClosePopup())}
    />
  </div>
);

export const FooterModal1 = ({
  submit,
  cancelText,
  disabled,
  submitText,
  cancel,
}) => (
  <div className="footer">
    <Button
      label={cancelText || "No"}
      className="btns-secondarys"
      handleClick={() => (CheckValue(cancel) ? cancel() : ClosePopup())}
    />
    <Button
      label={submitText || "Yes"}
      disabled={CheckValue(disabled) ? disabled : false}
      className="btns-primary"
      handleClick={submit}
    />
  </div>
);

export const UserStatusChangePopup = ({ title, submit, ...props }) => {
  const tempForm = FormBuilder.group({
    comment: ["", [Validators.required, Validators.minLength(3)]],
  });
  return (
    <MainDivModal clas="formModal">
      <ModalHeader title={title} />
      <FieldGroup
        control={tempForm}
        render={({ get, invalid }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (!invalid) {
                submit(tempForm.value.comment);
              }
            }}
          >
            <FormGroups>
              <FieldControl
                name="comment"
                render={TextArea}
                meta={{
                  label: "",
                  rows: "5",
                  type: "text",
                  minLength: "3",
                  maxLength: 400,
                  placeholder: "",
                  valid: true,
                }}
              />
            </FormGroups>
            <FormFooterModal
              {...props}
              submitText="Submit"
              invalid={invalid}
              submit={() => submit(tempForm.value.comment)}
            />
          </form>
        )}
      />
    </MainDivModal>
  );
};

export const RecurringScheduleActivityModal = ({
  handleClick,
  text,
  ...props
}) => {
  const tempForm = FormBuilder.group({
    single: ["", Validators.required],
  });
  return (
    <MainDivModal clas="formModal">
      <ModalHeader
        title={
          text ||
          `This is a recurring ${staticVar.activity}. Do you wish to cancel?`
        }
      />
      {/* <ModalHeader title="Link Video" /> */}
      <FieldGroup
        control={tempForm}
        render={({ get, invalid }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (!invalid) {
                handleClick(tempForm.value.single);
              }
            }}
          >
            <FormGroups>
              <FieldControl
                name="single"
                render={RadioInput}
                meta={{
                  label: `This ${staticVar.activity}`,
                  type: "radio",
                  valid: true,
                  validation: true,
                }}
              />
            </FormGroups>
            <FormGroups>
              <FieldControl
                name="single"
                render={RadioInput}
                meta={{
                  label: `All ${staticVar.activity}`,
                  type: "radio",
                  valid: true,
                  validation: true,
                }}
              />
            </FormGroups>
            <FormFooterModal
              {...props}
              submitText="Yes"
              invalid={invalid}
              submit={() => handleClick(tempForm.value.single)}
            />
          </form>
        )}
      />
    </MainDivModal>
  );
};

export default Modals;
